import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";
import { env } from "../../../../env";
import axiosInstance from "../../../globalInspector/axiosInstance";
import { toast } from "react-toastify";

const baseUrl = env.REACT_APP_BASE_URL;

// Thunk for Credit and Debit amount
export const creditAndDebitAmount = createAsyncThunk(
  "creditAndDebitAmount",
  async ({ entity_id, period }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/statistics/statement/credit_and_debit_amounts`,
        {
          params: {
            entity_id,
            period,
          },
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Thunk for Idle funds
export const idleFunds = createAsyncThunk(
  "idleFunds",
  async ({ owner_acct_id, period }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/statistics/statement/${owner_acct_id}/idle_funds`,
        {
          params: { period },
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching idle funds:", error);
      return rejectWithValue(error);
    }
  },
);

// Thunk for OD Interest Saved
export const OdInterestSavedThunk = createAsyncThunk(
  "OdInterestSavedThunk",
  async ({ entity_id, owner_acct_ids, period }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/statistics/generate_on_idle_fund_report`,
        {
          params: {
            entity_id,
            period,
            owner_account_ids: owner_acct_ids,
          },
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Thunk for Accounts per day
export const AccountsPerDayThunk = createAsyncThunk(
  "AccountsPerDayThunk",
  async ({ entity_id, account_type, period }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/statistics/statement/accounts_per_day_report`,
        {
          params: {
            entity_id,
            period,
            account_type: account_type,
          },
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Thunk for Transaction per day
export const TransactionPerDayThunk = createAsyncThunk(
  "TransactionPerDayThunk",
  async ({ entity_id, transaction_type, period }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/statistics/statement/transactions_per_day_report`,
        {
          params: {
            entity_id,
            period,
            transaction_type: transaction_type,
          },
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Thunk for Bene Transaction Count

export const beneTransactionCount = createAsyncThunk(
  "beneTransactionCount",
  async ({ entity_id, period }, { rejectWithValue }) => {
    try {
      const url = `${baseUrl}/statistics/beneficiary/transaction_count?entity_id=${entity_id}&period=${period}`;

      const response = await axiosInstance.get(url, {});

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Thunk for Internal Transaction Count
export const internalTransactionCount = createAsyncThunk(
  "internalTransactionCount",
  async ({ entity_id, period }, { rejectWithValue }) => {
    try {
      const url = `${baseUrl}/statistics/internal/transaction_count?entity_id=${entity_id}&period=${period}`;

      const response = await axiosInstance.get(url, {});

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Thunk for Productivity Tracker
export const ProductivityTrackerThunk = createAsyncThunk(
  "ProductivityTrackerThunk",
  async ({ entity_id, user_ids, period, reportType }, { rejectWithValue }) => {
    try {
      const endpoint =
        reportType === "bene"
          ? "/statistics/beneficiary/user_productivity_tracker"
          : reportType === "field_force"
            ? "/statistics/field_force/field_force_productivity_tracker"
            : reportType === "reimbursement"
              ? "/statistics/reimbursement/reimbursement_productivity_tracker"
              : "/statistics/internal/user_productivity_tracker";

      const response = await axiosInstance.get(`${baseUrl}${endpoint}`, {
        params: {
          entity_id,
          period,
          "user_ids[]": user_ids,
        },
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error while fetching data:", error);
      return rejectWithValue(error);
    }
  },
);

// Thunk for Field Force Transaction Count
export const fieldForceTransactionCount = createAsyncThunk(
  "fieldForceTransactionCount",
  async ({ entity_id, period }, { rejectWithValue }) => {
    try {
      const url = `${baseUrl}/statistics/field_force/transaction_count?entity_id=${entity_id}&period=${period}`;

      const response = await axiosInstance.get(url, {});

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Thunk for Reimbursement Transaction Count
export const reimbursementTransactionCount = createAsyncThunk(
  "reimbursementTransactionCount",
  async ({ entity_id, period }, { rejectWithValue }) => {
    try {
      const url = `${baseUrl}/statistics/reimbursement/transaction_count?entity_id=${entity_id}&period=${period}`;

      const response = await axiosInstance.get(url, {});

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Thunk for Cash Coverage Period
export const CashCoveragePeriodThunk = createAsyncThunk(
  "CashCoveragePeriodThunk",
  async ({ entity_id }, { rejectWithValue }) => {
    try {
      const url = `${baseUrl}/statistics/statement/cash_coverage_report?entity_id=${entity_id}`;

      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Thunk for to fetch widgets
export const fetchWidgets = createAsyncThunk(
  "getWidgets",
  async (_, { rejectWithValue }) => {
    try {
      const url = `${baseUrl}/statistics/widgets`;
      const response = await axiosInstance.get(url, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Thunk to Add Widget (POST)
export const addWidget = createAsyncThunk(
  "addWidget",
  async ({ widget_id, filters = {} }, { rejectWithValue }) => {
    try {
      const url = `${baseUrl}/statistics/widgets`;
      const response = await axiosInstance.post(
        url,
        { widget_id, filters },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      if (response.data?.status) {
        CommonToast({
          text: "Added to home.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }
      return response.data;
    } catch (error) {
      CommonToast({
        text: "Failed to add to home.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error);
    }
  },
);

// Thunk to Remove Widget (DELETE)
export const removeWidget = createAsyncThunk(
  "removeWidget",
  async ({ widget_id }, { rejectWithValue }) => {
    try {
      const url = `${baseUrl}/statistics/widgets`;
      const response = await axiosInstance.delete(url, {
        data: { widget_id },
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });

      if (response.data?.status) {
        CommonToast({
          text: "Removed from home.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
      }
      return response.data;
    } catch (error) {
      CommonToast({
        text: "Failed to remove from home.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error);
    }
  },
);

// MIS Report API
export const MisReportCreateDownload = createAsyncThunk(
  "MisReportCreateDownload",
  async (values, { rejectWithValue }) => {
    try {
      const format = (values?.formatType || "xlsx").toString().toLowerCase();
      const response = await axiosInstance.post(
        `${baseUrl}/mis_report.${format}`,
        JSON?.stringify(values?.payload),
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          responseType: "blob",
        },
      );
      let blob = response.data;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `MIS_Report.${format}`);

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      let errorMessage = "Something went wrong";

      try {
        const errorBlob = await error.response.data;
        const text = await errorBlob.text();
        const parsed = JSON.parse(text);

        errorMessage =
          parsed?.errors?.base[0] ||
          parsed?.errors?.token_expired ||
          parsed?.errors?.message ||
          parsed?.message ||
          parsed?.error ||
          error.message ||
          "Something went wrong";
      } catch (err) {
        errorMessage = error.message || "Something went wrong";
      }
      toast.dismiss();
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return rejectWithValue(errorMessage);
    }
  },
);

// Slice
const settingStatistics = createSlice({
  name: "settingStatistics",
  initialState: {
    // States for Credit and Debit Amount
    creditAndDebitAmountLoading: false,
    creditAndDebitAmountData: null,
    creditAndDebitAmountError: null,

    // States for Idle Funds
    idleFundsLoading: false,
    idleFundsData: null,
    idleFundsError: null,

    // States for OD Interest Saved
    OdInterestSavedLoading: false,
    OdInterestSavedData: null,
    OdInterestSavedError: null,

    // States for Bene Transaction Count
    beneTransactionCountLoading: false,
    beneTransactionCountData: null,
    beneTransactionCountError: null,

    // States for Internal Transaction Count
    internalTransactionCountLoading: false,
    internalTransactionCountData: null,
    internalTransactionCountError: null,

    // States for Field Force Transaction Count
    fieldForceTransactionCountLoading: false,
    fieldForceTransactionCountData: null,
    fieldForceTransactionCountError: null,

    // States for Reimbursement Transaction Count
    reimbursementTransactionCountLoading: false,
    reimbursementTransactionCountData: null,
    reimbursementTransactionCountError: null,

    // States for Productivity Tracker Thunk
    ProductivityTrackerThunkLoading: false,
    ProductivityTrackerThunkData: null,
    ProductivityTrackerThunkError: null,

    // States for Cash Coverage Period
    CashCoveragePeriodThunkLoading: false,
    CashCoveragePeriodThunkData: null,
    CashCoveragePeriodThunkError: null,

    // States for Widgets
    widgetsData: { widgets: [] },
    widgetsLoading: false,
    widgetsError: null,
    addWidgetLoading: false,
    removeWidgetLoading: false,

    // States for MIS Report
    MisReportCreateData: null,
    MisReportLoading: true,
    MisReportError: null,

    // States for Accounts Per Day
    AccountsPerDayLoading: false,
    AccountsPerDayData: null,
    AccountsPerDayError: null,

    // States for Transation Per Day
    TransactionPerDayLoading: false,
    TransactionPerDayData: null,
    TransactionPerDayError: null,
  },
  reducers: {
    resetError: (state, action) => {
      state.beneTransactionCountError = null;
      state.internalTransactionCountError = null;
      state.fieldForceTransactionCountError = null;
      state.reimbursementTransactionCountError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creditAndDebitAmount.pending, (state) => {
        state.creditAndDebitAmountLoading = true;
        state.creditAndDebitAmountError = null;
      })
      .addCase(creditAndDebitAmount.fulfilled, (state, action) => {
        state.creditAndDebitAmountLoading = false;
        state.creditAndDebitAmountData = action.payload;
      })
      .addCase(creditAndDebitAmount.rejected, (state, action) => {
        state.creditAndDebitAmountLoading = false;
        state.creditAndDebitAmountError = action.payload?.status;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })

      // Cases for Idle Funds
      .addCase(idleFunds.pending, (state) => {
        state.idleFundsLoading = true;
        state.idleFundsError = null;
      })
      .addCase(idleFunds.fulfilled, (state, action) => {
        state.idleFundsLoading = false;
        state.idleFundsData = action.payload;
      })
      .addCase(idleFunds.rejected, (state, action) => {
        state.idleFundsLoading = false;
        state.idleFundsError = action.payload?.status || true;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })

      // Cases for OD Interest Saved
      .addCase(OdInterestSavedThunk.pending, (state) => {
        state.OdInterestSavedLoading = true;
        state.OdInterestSavedError = null;
      })
      .addCase(OdInterestSavedThunk.fulfilled, (state, action) => {
        state.OdInterestSavedLoading = false;
        state.OdInterestSavedData = action.payload;
      })
      .addCase(OdInterestSavedThunk.rejected, (state, action) => {
        state.OdInterestSavedLoading = false;
        state.OdInterestSavedError = action.payload?.status || true;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })

      // Cases for Account per day Saved
      .addCase(AccountsPerDayThunk.pending, (state) => {
        state.AccountsPerDayLoading = true;
        state.AccountsPerDayError = null;
      })
      .addCase(AccountsPerDayThunk.fulfilled, (state, action) => {
        state.AccountsPerDayLoading = false;
        state.AccountsPerDayData = action.payload;
      })
      .addCase(AccountsPerDayThunk.rejected, (state, action) => {
        state.AccountsPerDayLoading = false;
        state.AccountsPerDayError = action.payload?.status || true;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })

      // Cases for Transaction per day
      .addCase(TransactionPerDayThunk.pending, (state) => {
        state.TransactionPerDayLoading = true;
        state.TransactionPerDayError = null;
      })
      .addCase(TransactionPerDayThunk.fulfilled, (state, action) => {
        state.TransactionPerDayLoading = false;
        state.TransactionPerDayData = action.payload;
      })
      .addCase(TransactionPerDayThunk.rejected, (state, action) => {
        state.TransactionPerDayLoading = false;
        state.TransactionPerDayError = action.payload?.status || true;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })

      // Cases for Bene Transaction Count
      .addCase(beneTransactionCount.pending, (state) => {
        state.beneTransactionCountLoading = true;
        state.beneTransactionCountError = null;
      })
      .addCase(beneTransactionCount.fulfilled, (state, action) => {
        state.beneTransactionCountLoading = false;
        state.beneTransactionCountData = action.payload;
      })
      .addCase(beneTransactionCount.rejected, (state, action) => {
        state.beneTransactionCountLoading = false;
        state.beneTransactionCountError = action.payload?.status || true;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })

      // Cases for Internal Transaction Count
      .addCase(internalTransactionCount.pending, (state) => {
        state.internalTransactionCountLoading = true;
        state.internalTransactionCountError = null;
      })
      .addCase(internalTransactionCount.fulfilled, (state, action) => {
        state.internalTransactionCountLoading = false;
        state.internalTransactionCountData = action.payload;
      })
      .addCase(internalTransactionCount.rejected, (state, action) => {
        state.internalTransactionCountLoading = false;
        state.internalTransactionCountError = action.payload?.status || true;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })

      // Cases for Field Force Transaction Count
      .addCase(fieldForceTransactionCount.pending, (state) => {
        state.fieldForceTransactionCountLoading = true;
        state.fieldForceTransactionCountError = null;
      })
      .addCase(fieldForceTransactionCount.fulfilled, (state, action) => {
        state.fieldForceTransactionCountLoading = false;
        state.fieldForceTransactionCountData = action.payload;
      })
      .addCase(fieldForceTransactionCount.rejected, (state, action) => {
        state.fieldForceTransactionCountLoading = false;
        state.fieldForceTransactionCountError = action.payload?.status || true;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })

      // Cases for Reimbursement Transaction Count
      .addCase(reimbursementTransactionCount.pending, (state) => {
        state.reimbursementTransactionCountLoading = true;
        state.reimbursementTransactionCountError = null;
      })
      .addCase(reimbursementTransactionCount.fulfilled, (state, action) => {
        state.reimbursementTransactionCountLoading = false;
        state.reimbursementTransactionCountData = action.payload;
      })
      .addCase(reimbursementTransactionCount.rejected, (state, action) => {
        state.reimbursementTransactionCountLoading = false;
        state.reimbursementTransactionCountError =
          action.payload?.status || true;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })

      // Cases for Productivity tracker
      .addCase(ProductivityTrackerThunk.pending, (state) => {
        state.ProductivityTrackerThunkLoading = true;
        state.ProductivityTrackerThunkError = null;
      })
      .addCase(ProductivityTrackerThunk.fulfilled, (state, action) => {
        state.ProductivityTrackerThunkLoading = false;
        state.ProductivityTrackerThunkData = action.payload;
      })
      .addCase(ProductivityTrackerThunk.rejected, (state, action) => {
        state.ProductivityTrackerThunkLoading = false;
        state.ProductivityTrackerThunkError = action.payload?.status || true;
        // if (action?.payload?.status !== 404) {
        //   CommonToast({
        //     text: "Failed to fetch.",
        //     icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        //     variant: "var(--error)",
        //     buttonNeeded: false,
        //   });
        // }
      })

      // Cases for Cash Coverage Period
      .addCase(CashCoveragePeriodThunk.pending, (state) => {
        state.CashCoveragePeriodThunkLoading = true;
        state.CashCoveragePeriodThunkError = null;
      })
      .addCase(CashCoveragePeriodThunk.fulfilled, (state, action) => {
        state.CashCoveragePeriodThunkLoading = false;
        state.CashCoveragePeriodThunkData = action.payload;
      })
      .addCase(CashCoveragePeriodThunk.rejected, (state, action) => {
        state.CashCoveragePeriodThunkLoading = false;
        state.CashCoveragePeriodThunkError = action.payload?.status || true;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })

      // Cases for Widgets
      .addCase(fetchWidgets.pending, (state) => {
        state.widgetsLoading = true;
        state.widgetsError = null;
      })
      .addCase(fetchWidgets.fulfilled, (state, action) => {
        state.widgetsLoading = false;
        state.widgetsData = action.payload;
      })
      .addCase(fetchWidgets.rejected, (state, action) => {
        state.widgetsLoading = false;
        state.widgetsError = action.payload?.status || true;
        if (action?.payload?.status !== 404) {
          CommonToast({
            text: "Failed to fetch widgets.",
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      })
      .addCase(addWidget.pending, (state) => {
        state.addWidgetLoading = true;
      })
      .addCase(addWidget.fulfilled, (state, action) => {
        const addedId = action.meta.arg;
        state.widgetsData?.widgets?.push(addedId);
        state.addWidgetLoading = false;
      })
      .addCase(addWidget.rejected, (state) => {
        state.addWidgetLoading = false;
      })
      .addCase(removeWidget.pending, (state) => {
        state.removeWidgetLoading = true;
      })
      .addCase(removeWidget.fulfilled, (state, action) => {
        const removedId = action.meta.arg.widget_id;
        state.widgetsData.widgets = state.widgetsData?.widgets?.filter(
          (widget) => widget.widget_id !== removedId,
        );
        state.removeWidgetLoading = false;
      })
      .addCase(removeWidget.rejected, (state) => {
        state.removeWidgetLoading = false;
      })

      // Cases for MisReportCreateDownload
      .addCase(MisReportCreateDownload.pending, (state) => {
        state.MisReportLoading = true;
        state.MisReportError = null;
      })
      .addCase(MisReportCreateDownload.fulfilled, (state, action) => {
        state.MisReportLoading = false;
        state.MisReportCreateData = action?.payload;
      })
      .addCase(MisReportCreateDownload.rejected, (state, action) => {
        state.MisReportLoading = false;
        state.MisReportCreateData = false;
        state.MisReportError = action?.payload;
      });
  },
});

export const { resetError } = settingStatistics.actions;
export default settingStatistics.reducer;
